/**
 * Округление числа до заданного числа знаков после запятой.
 * Единая реализация для ext_function и изолированных unit-тестов (без UserStore/config).
 */
export function roundNumber(
    number: number | null | undefined,
    roundDigits?: number | null
): number | null {
    if (number == null) return null;
    if (roundDigits == null || (roundDigits >= 0 && Number.isInteger(number))) return number;
    const mult = 10 ** roundDigits;
    const powed = number * mult;
    return (
        Math.round(powed + Math.sign(number) * 0.1 ** (16 - 2 - (Math.round(powed) / mult).toString().length)) /
        mult
    );
}
